import React from 'react';

export default class Circle extends React.PureComponent {
  render() {
    const radius = this.props.canvasSize / 2;
    return (
      <circle cx={radius} cy={radius} r={radius} className="fill-current" />
    );
  }
}
